/// <reference types="vite-plugin-svgr/client" />

import "./App.scss";
import "./i18n/i18n";

import { Toaster } from "react-hot-toast";
import { BrowserRouter as Router } from "react-router-dom";

import AppRouter from "./app/router/AppRouter";
import CookieConsent from "./components/CookieConsent/CookieConsent";
import UpgradeModal from "./components/UpgradeModal/UpgradeModal";
import { ErrorBoundary } from "./covaltech-react-ui";

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <AppRouter />
        <Toaster position="bottom-right" reverseOrder={false} />
        <UpgradeModal />
        <CookieConsent />
      </Router>
    </ErrorBoundary>
  );
}

export default App;
